import { useEffect, useState } from "react";

// Prazo de preparação (fazer a peça, em dias úteis), definido pela Alexandra no painel. Não inclui o transporte.
import { API_URL } from "@/lib/backend";
const NONE = { configured: false, minDays: null, maxDays: null, note: null, text: null };

let current = null; // null = ainda não carregado
const listeners = new Set();
const publish = (v) => {
  current = v;
  listeners.forEach((fn) => fn(v));
};

export const refreshLeadTime = async () => {
  if (!API_URL) {
    publish(NONE);
    return NONE;
  }
  try {
    const res = await fetch(`${API_URL}/settings/lead-time`, { cache: "no-store" });
    const data = res.ok ? await res.json() : NONE;
    publish(data);
    return data;
  } catch {
    publish(NONE);
    return NONE;
  }
};

export const useLeadTime = () => {
  const [value, setValue] = useState(current);
  useEffect(() => {
    listeners.add(setValue);
    if (current === null) refreshLeadTime();
    else setValue(current);
    return () => listeners.delete(setValue);
  }, []);
  return value;
};

// O que enviar na confirmação: a estimativa que a cliente viu (0 e 0 quando não havia).
export const leadTimeSeen = (lt) => ({ min_days: lt?.configured ? lt.minDays : 0, max_days: lt?.configured ? lt.maxDays : 0 });

// Idem para o acréscimo dos padrões "por encomenda" (combineExtras): se mudou entretanto, o servidor pede nova confirmação.
export const patternExtraSeen = (extra) => ({ min_days: extra?.min ?? 0, max_days: extra?.max ?? 0 });
